/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-09 16:53:23
 * @LastEditors: game.pluto.com 66291979@qq.com
 * @LastEditTime: 2025-03-04 17:41:42
 * @FilePath: \lobby\src\utils\helper.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { getLocalStorage, Key } from '@/common/localStorage'
import { checkForUpdate, downloadAndSaveAPK, VERSION_JSON_URL } from '@/common/updateService'
import { BUS } from '@/event/EventCenter'
import { getLocale, i18n } from '@/locales'
import { useUserStore } from '@/stores/user'
import { Base64 } from 'js-base64'
import { closeToast, showLoadingToast, showSuccessToast } from 'vant'

async function checkAndUpdateApp() {
  const currentVersionCode = __APP_VERSION__ // 当前应用的版本号

  try {
    // 检查是否有更新
    const apkUrl = await checkForUpdate(currentVersionCode)

    if (apkUrl) {
      // alert('检测到新版本，正在下载...')
      showLoadingToast({
        message: i18n.global.t('app.downloading') + '...',
        duration: 10000,
        forbidClick: true
      })
      // 下载 APK 文件
      const apkPath = await downloadAndSaveAPK(apkUrl)

      if (apkPath) {
        // 打开 APK 文件（当前使用 Browser）
        // await Browser.open({ url: apkUrl })
        const anchor = document.createElement('a')
        anchor.href = apkUrl
        anchor.download = '' // 可选：给文件命名
        anchor.target = '_blank' // 确保在新标签页打开

        // 模拟点击下载
        anchor.click()

        // 移除 a 标签
        anchor.remove()
        closeToast()
      }
      closeToast()
    } else {
      console.log('当前已是最新版本')
    }
  } catch (error) {
    console.log(`检查更新失败: ${error}`)
  }
}

async function downloadAPK(country) {
  showLoadingToast({
    message: i18n.global.t('app.downloading') + '...',
    duration: 10000,
    forbidClick: true
  })
  const response = await fetch(VERSION_JSON_URL, {
    cache: 'no-cache' // 避免缓存问题
  })
  if (!response.ok) {
    closeToast()
    throw new Error(`网络请求失败，状态码: ${response.status}`)
  }

  const { staging, production } = await response.json()

  const apkUrl = __APP_ENV__ === 'staging' ? staging[country].apkUrl : production[country].apkUrl
  // if (__APP_ENV__ == 'app_staging' || __APP_ENV__ == 'app') {
  //   // 下载 APK 文件
  //   const apkPath = await downloadAndSaveAPK(apkUrl)

  //   if (apkPath) {
  //     // alert('下载完成，正在安装新版本')
  //     closeToast()
  //     // 打开 APK 文件（当前使用 Browser）
  //     await Browser.open({ url: apkPath })
  //   }
  // } else {
  // 动态创建 a 标签
  const anchor = document.createElement('a')
  anchor.href = apkUrl
  anchor.download = '' // 可选：给文件命名
  anchor.target = '_blank' // 确保在新标签页打开

  // 模拟点击下载
  anchor.click()

  // 移除 a 标签
  anchor.remove()
  closeToast()
  // // 提示用户
  // this.$toast('下载已启动，请查看通知栏或下载管理器。')
  // }
}

async function savePWA() {
  if (__APP_ENV__ == 'app_staging' || __APP_ENV__ == 'app') {
    return
  }
  if (window.deferredPrompt) {
    window.deferredPrompt.prompt()
    // 监听用户的选择结果
    let choiceResult = await window.deferredPrompt.userChoice
    if (choiceResult.outcome === 'accepted') {
      console.log('用户接受了安装提示')
    } else {
      console.log('用户拒绝了安装提示')
    }
    // 使用完事件后清除引用
    window.deferredPrompt = null
  }
  if (window.top.deferredPrompt) {
    window.top.deferredPrompt.prompt()
    // 监听用户的选择结果
    let choiceResult = await window.top.deferredPrompt.userChoice
    if (choiceResult.outcome === 'accepted') {
      console.log('用户接受了安装提示')
    } else {
      console.log('用户拒绝了安装提示')
    }
    // 使用完事件后清除引用
    window.deferredPrompt = null
  }
}
/**
 * 加密
 * @param {String} decode 要加密的字符串
 * @returns
 */
function encodeBase64(decode) {
  return Base64.encode(decode)
}
/**
 * 解密
 * @param {String} encoded 要解密的字符串
 * @returns
 */
function decodeBase64(encoded) {
  return Base64.decode(encoded)
}

/**
 * 拷贝
 * @param {String} str
 */
function copy(str) {
  const textarea = document.createElement('textarea')
  textarea.value = str
  textarea.setAttribute('name', 'copy-text-area')
  document.body.appendChild(textarea)
  textarea.select()

  try {
    // 尝试执行复制操作
    const success = document.execCommand('copy')
    if (success) {
      console.log('复制成功')
      showSuccessToast({
        message: this.$t('message.copysucess'),
        wordBreak: 'break-word',
        duration: 3000
      })
    } else {
      console.log('复制失败')
    }
  } catch (error) {
    console.error('复制失败:', error)
  }
  document.body.removeChild(textarea)
}

/**
 * 脱敏
 * @param {String | Number} id
 * @returns
 */
function fillterLongID(id, decimal = '***') {
  id = id + ''
  // 脱敏处理：保留前3位和后3位，中间用星号(*)替换
  let desensitizedCardNumber =
    id.substring(0, 3) + decimal.substr(0, id.length - 6) + id.substring(id.length - 3)
  return desensitizedCardNumber
}

/**
 * 对用户名进行脱敏处理
 * @param {String} id - 用户名
 * @param {String} decimal - 用于替换的字符串，默认为 '****'
 * @returns {String} - 脱敏后的用户名
 */
function fillterLongUserName(id, decimal = '****') {
  // 将 id 转换为字符串
  id = id + ''
  // 返回脱敏后的用户名，只显示最后四位，其余部分用 decimal 替换
  return `${decimal}${id.substring(id.length - 4)}`
}

/**
 * 格式化金额
 * @param {Number} amount 金额
 * @param {Number} decimalCount 精度
 * @param {String} decimal 小数点符号
 * @param {String} thousands 千位符符号
 * @returns
 */
function formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
  try {
    decimalCount = Math.abs(decimalCount)
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount

    const negativeSign = amount < 0 ? '-' : ''

    let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()
    let j = i.length > 3 ? i.length % 3 : 0

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - parseInt(amount))
            .toFixed(decimalCount)
            .slice(2)
        : '')
    )
  } catch (e) {
    console.log(e)
  }
  // 使用示例
  // console.log(formatMoney(1234567.89)) // 输出: "1,234,567.89"
  // console.log(formatMoney(-1234567.89)) // 输出: "-1,234,567.89"
  // console.log(formatMoney(1234567.89123)) // 输出: "1,234,567.89"（因为小数位被限制为两位）
}

/**
 * 过滤千分符
 * @param {String} str 带千分符的数字字符串
 * @returns
 */
function removeThousandSeparatorWithDecimal(str) {
  if (typeof str == 'number') {
    return str
  }
  // 替换所有非数字字符，除了小数点
  return Number(str.replace(/[^\d.]/g, ''))
}

/**
 * 拆解一维数组为二维数组
 * @param {Array} array 一维数组
 * @param {Number} chunkSize 拆分长度
 * @param {Boolean} needComplete 是否补全最后一个子数组不足固长元素为null
 * @returns
 */
function chunkArray(array, chunkSize, needComplete = false) {
  if (!array || array.length == 0) {
    return []
  }
  let result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    let chunk = array.slice(i, i + chunkSize)
    result.push(chunk)
  }
  if (needComplete && result[result.length - 1].length < chunkSize) {
    for (let j = 0; j <= chunkSize - result[result.length - 1].length; j++) {
      result[result.length - 1].push(null)
    }
  }
  return result
}

/**
 * 获取随机整数
 * @param {Number} min 闭区间最小值
 * @param {Number} max 闭区间最大值
 * @returns
 */
function getRandomIntInclusive(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 解析透明传参
 * @param {String} url
 * @returns
 */
function parseUrl(url = window.location.href) {
  // 创建URL对象
  const parsedUrl = new URL(url)

  // 使用URLSearchParams解析查询参数
  const params = new URLSearchParams(parsedUrl.search)

  // 获取所有参数并输出
  params.forEach((value, key) => {
    console.log(`${key}: ${value}`)
  })

  return params
}

/**
 * 将文本拆分成长度为一定长度的子文本数组
 * @param {String} text 原文本
 * @param {Number} length 拆分长度
 * @returns  拆分后子文本数组
 * @example 
      let text = "这是一个测试字符串，用于演示如何将文本拆分成固定长度的子字符串数组。";
      let length = 5;
      let splitArray = splitText(text, length);
      [  "这是一个测",  "试字符串，",  "用于演示如",  "何将文本拆",  "分成固定长",  "度的子字符",  "串数组。"]

 */
function splitText(text, length) {
  let result = []
  for (let i = 0; i < text.length; i += length) {
    result.push(text.substring(i, i + length))
  }
  return result.reverse()
}

function unitConversion(code) {
  // if (code == 'ETB') {
  //   return 'BIRR'
  // }
  return code
}

function formatNavTab(name) {
  return name.substring(0, 1).toUpperCase() + name.substring(1).toLowerCase()
}

function truncateText(text, maxLength) {
  if (text.length <= maxLength) {
    return text
  }
  return text.slice(0, maxLength - 3) + '...'
}

function formatDate(time) {
  let date = new Date(time)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let min = date.getMinutes()
  let second = date.getSeconds()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  hour = hour < 10 ? '0' + hour : hour
  min = min < 10 ? '0' + min : min
  second = second < 10 ? '0' + second : second
  console.log(date)
  return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + second
}

function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return IOS
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return ANDROID
  }

  // Windows Phone detection
  if (/windows phone/i.test(userAgent)) {
    return 'windowsphone'
  }

  // Fallback for unknown OS
  return 'unknown'
}

function isNativeApp() {
  return import.meta.env.VITE_APP_ENV == 'app' || import.meta.env.VITE_APP_ENV == 'app_staging'
}

/**
 * 从二维数组中查找目标值的索引
 * @param {*} arr
 * @param {*} target
 * @returns
 */
function findValueIn2DArray(arr, target) {
  const flatArr = arr.flatMap((row, rowIndex) =>
    row.map((col, colIndex) => ({ rowIndex, colIndex, value: col }))
  )

  const targetObj = flatArr.find((obj) => obj.value === target)

  return targetObj ? [targetObj.rowIndex, targetObj.colIndex] : null
}

const currentPage = {
  HOME: 'home',
  LOGIN: 'login',
  REGISTER: 'register',
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
  ACTIVE: 'active'
}
/**
 * 设置seo关键词
 * @param {*} currentPage 当前页   home(首页) | login(登录) | register(注册) | deposit(充值) | withdraw(提现) | active(活动)
 * @param {*} country ET(埃塞) | CI(科特) | KE(肯尼亚)
 */
function setSEO(currentPage, country) {
  const seo = {
    home: {
      title: {
        ET: 'Experience top-tier sports betting at Vivabet Ethiopia! Bet on major global and local events with live odds. Enjoy a welcome freebet, weekly bonuses, and exclusive cashback offers. Our secure, mobile-friendly platform ensures fast withdrawals and 24/7 customer support tailored for Ethiopian sports enthusiasts.',
        GH: 'BigWins Casino offers an extensive range of games. Dive into a world with thousands of exciting options and win big!',
        TZ: 'Kasino ya Vivagame: Cheza Maelfu ya Michezo na Ushinde Kubwa!',
        CI: "Le casino Vivagame propose plusieurs gammes de jeux. Plongez dans un monde avec des milliers d'options passionnantes pour gagner des milliards.",
        KE: 'Vivagame Casino offers an extensive range of games. Dive into a world with thousands of exciting options and win big!'
      },
      content: {
        ET: 'Experience top-tier sports betting at Vivabet Ethiopia! Bet on major global and local events with live odds. Enjoy a welcome freebet, weekly bonuses, and exclusive cashback offers. Our secure, mobile-friendly platform ensures fast withdrawals and 24/7 customer support tailored for Ethiopian sports enthusiasts.',
        GH: 'BigWins Casino offers an extensive range of games. Dive into a world with thousands of exciting options and win big!',
        TZ: 'Vivagame Casino inatoa anuwai ya michezo. Ingia katika ulimwengu ulio na maelfu ya chaguzi za kufurahisha na ushinde sana!',
        CI: "Le casino Vivagame propose plusieurs gammes de jeux. Plongez dans un monde avec des milliers d'options passionnantes pour gagner des milliards.",
        KE: 'Vivagame Casino offers an extensive range of games. Dive into a world with thousands of exciting options and win big!'
      }
    },
    login: {
      title: {
        ET: 'Log In to Win Big | Start Winning',
        GH: 'Log In to Win Big | Access Your Casino Account and Start Winning',
        TZ: 'Ingia Ili Ushinde Kubwa | Fikia Akaunti Yako ya Kasino na Uanze Kushinda',
        CI: 'Connectez-vous pour gagner gros | Accédez à votre compte casino et commencez à gagner',
        KE: 'Log In to Win Big | Access Your Casino Account and Start Winning'
      },
      content: {
        ET: 'Experience top-tier sports betting at Vivabet Ethiopia! Bet on major global and local events with live odds. Enjoy a welcome freebet, weekly bonuses, and exclusive cashback offers. Our secure, mobile-friendly platform ensures fast withdrawals and 24/7 customer support tailored for Ethiopian sports enthusiasts.',
        GH: "Log in to our casino and get closer to your next big win! Access thrilling games, exclusive bonuses, and real cash prizes. Don't miss your chance to hit the jackpot—sign in now and turn your luck into real money today!",
        TZ: 'Ingia kwenye kasino yetu na usogee karibu na ushindi wako mkubwa ujao! Fikia michezo ya kusisimua, bonasi za kipekee, na zawadi za pesa halisi. Usikose nafasi yako ya kushinda jackpot—ingia sasa na badilisha bahati yako kuwa pesa halisi leo!',
        CI: "Connectez-vous à notre casino et rapprochez-vous de votre prochain gros gain ! Accédez à des jeux palpitants, des bonus exclusifs et des gains en argent réel. Ne manquez pas votre chance de décrocher le jackpot — connectez-vous maintenant et transformez votre chance en argent réel dès aujourd'hui !",
        KE: "Log in to our casino and get closer to your next big win! Access thrilling games, exclusive bonuses, and real cash prizes. Don't miss your chance to hit the jackpot—sign in now and turn your luck into real money today!"
      }
    },
    register: {
      title: {
        ET: 'Sign Up and Claim Your Welcome Bonus | Join Our Games Today',
        GH: 'Sign Up and Claim Your Welcome Bonus | Join Our Casino Today',
        TZ: 'Jisajili na Pata Bonasi Yako ya Kukaribishwa | Jiunge na Kasino Yetu Leo',
        CI: "Inscrivez-vous et réclamez votre bonus de bienvenue | Rejoignez notre casino dès aujourd'hui",
        KE: 'Sign Up and Claim Your Welcome Bonus | Join Our Casino Today'
      },
      content: {
        ET: 'Experience top-tier sports betting at Vivabet Ethiopia! Bet on major global and local events with live odds. Enjoy a welcome freebet, weekly bonuses, and exclusive cashback offers. Our secure, mobile-friendly platform ensures fast withdrawals and 24/7 customer support tailored for Ethiopian sports enthusiasts.',
        GH: 'Register now at our online casino and unlock up to 20,000 bonus credits! Enjoy a seamless sign-up process and dive into a world of exciting games, exclusive promotions, and big wins. Join us today and start your winning journey!',
        TZ: 'Jisajili sasa kwenye kasino yetu ya mtandaoni! Furahia mchakato rahisi wa usajili, cheza michezo ya kusisimua, pata ofa za kipekee na ushinde zawadi kubwa. Jiunge nasi leo na anza safari yako ya ushindi!',
        CI: "Inscrivez-vous dès maintenant sur notre casino en ligne et débloquez jusqu'à 40 000 crédits bonus ! Profitez d'un processus d'inscription simple et plongez dans un monde de jeux excitants, de promotions exclusives et de gains conséquents. Rejoignez-nous dès aujourd'hui et commencez votre aventure gagnante !",
        KE: 'Register now at our online casino and unlock up to 10,000 bonus credits! Enjoy a seamless sign-up process and dive into a world of exciting games, exclusive promotions, and big wins. Join us today and start your winning journey!'
      }
    },
    deposit: {
      title: {
        ET: 'Fast and Secure Deposits | Top Up Your Games Account Instantly',
        GH: 'Fast and Secure Deposits | Top Up Your Casino Account Instantly',
        TZ: 'Amana za Haraka na Salama | Ongeza Salio kwenye Akaunti Yako ya Kasino Mara Moja',
        CI: 'Dépôts rapides et sécurisés | Rechargez votre compte casino instantanément',
        KE: 'Fast and Secure Deposits | Top Up Your Casino Account Instantly'
      },
      content: {
        ET: 'Make quick and secure deposits at our Games with multiple payment options. Funds are credited instantly, so you can jump back into the action without delay. Recharge your account now and enjoy uninterrupted gaming with fast access to your money!',
        GH: 'Make quick and secure deposits at our casino with multiple payment options. Funds are credited instantly, so you can jump back into the action without delay. Recharge your account now and enjoy uninterrupted gaming with fast access to your money!',
        TZ: 'Fanya amana za haraka na salama kwenye kasino yetu kwa kutumia chaguo mbalimbali za malipo. Fedha huwekwa papo hapo, hivyo unaweza kurudi kwenye mchezo bila kuchelewa. Ongeza salio kwenye akaunti yako sasa na furahia michezo bila usumbufu ukiwa na ufikiaji wa haraka wa pesa zako!',
        CI: "Effectuez des dépôts rapides et sécurisés sur notre casino avec plusieurs options de paiement. Les fonds sont crédités instantanément, vous permettant de retourner au jeu sans attendre. Rechargez votre compte maintenant et profitez d'une expérience de jeu ininterrompue avec un accès rapide à votre argent !",
        KE: 'Make quick and secure deposits at our casino with multiple payment options. Funds are credited instantly, so you can jump back into the action without delay. Recharge your account now and enjoy uninterrupted gaming with fast access to your money!'
      }
    },
    withdraw: {
      title: {
        ET: 'Fast Withdrawals with Real Payouts | Cash Out Your Winnings Now',
        GH: 'Fast Withdrawals with Real Payouts | Cash Out Your Winnings Now',
        TZ: 'Uondoaji wa Haraka na Malipo Halisi | Toa Ushindi Wako Sasa',
        CI: 'Retraits rapides avec paiements réels | Encaissez vos gains dès maintenant',
        KE: 'Fast Withdrawals with Real Payouts | Cash Out Your Winnings Now'
      },
      content: {
        ET: 'Enjoy quick and reliable withdrawals at our games, with real payouts directly to your account. Your winnings are processed swiftly and securely, ensuring fast access to your money. Cash out now and experience hassle-free, real-time transfers to your preferred method!',
        GH: 'Enjoy quick and reliable withdrawals at our casino, with real payouts directly to your account. Your winnings are processed swiftly and securely, ensuring fast access to your money. Cash out now and experience hassle-free, real-time transfers to your preferred method!',
        TZ: 'Furahia uondoaji wa haraka na wa kuaminika kwenye kasino yetu, huku malipo halisi yakiwekwa moja kwa moja kwenye akaunti yako. Ushindi wako unashughulikiwa kwa haraka na usalama, kuhakikisha unapata pesa zako bila kuchelewa. Toa pesa sasa na upate miamala isiyo na usumbufu, kwa muda halisi, kupitia njia yako unayopendelea!',
        CI: 'Profitez de retraits rapides et fiables sur notre casino, avec des paiements réels directement sur votre compte. Vos gains sont traités rapidement et en toute sécurité, vous assurant un accès rapide à votre argent. Encaissez dès maintenant et bénéficiez de transferts en temps réel sans tracas vers votre méthode de paiement préférée !',
        KE: 'Enjoy quick and reliable withdrawals at our casino, with real payouts directly to your account. Your winnings are processed swiftly and securely, ensuring fast access to your money. Cash out now and experience hassle-free, real-time transfers to your preferred method!'
      }
    },
    active: {
      title: {
        ET: 'Exciting Games Promotions | Recharge Bonuses & Cash Back Offers',
        GH: 'Exciting Casino Promotions | Recharge Bonuses & Cash Back Offers',
        TZ: 'Promosheni za Kusisimua za Kasino | Bonasi za Kujaza Salio & Ofa za Pesa Taslimu',
        CI: 'Promotions Casino Passionnantes | Bonus de Recharge & Offres de Cash Back',
        KE: 'Exciting Casino Promotions | Recharge Bonuses & Cash Back Offers'
      },
      content: {
        ET: 'Discover our latest games promotions, including generous recharge bonuses and attractive cash back offers. Take advantage of special deals to boost your play and maximize your winnings. Check out our current activities and enhance your gaming experience with exclusive rewards and cash back opportunities!',
        GH: 'Discover our latest casino promotions, including generous recharge bonuses and attractive cash back offers. Take advantage of special deals to boost your play and maximize your winnings. Check out our current activities and enhance your gaming experience with exclusive rewards and cash back opportunities!',
        TZ: 'Gundua promosheni zetu za hivi punde za kasino, zikiwemo bonasi kubwa za kujaza salio na ofa za kuvutia za pesa taslimu. Chukua fursa ya ofa maalum ili kuongeza mchezo wako na kuongeza ushindi wako. Angalia shughuli zetu za sasa na boresha uzoefu wako wa michezo ya kubahatisha kwa zawadi za kipekee na fursa za pesa taslimu!',
        CI: 'Découvrez nos dernières promotions casino, incluant des bonus généreux sur les recharges et des offres attrayantes de cash back. Profitez des offres spéciales pour dynamiser votre jeu et maximiser vos gains. Consultez nos activités en cours et améliorez votre expérience de jeu avec des récompenses exclusives et des opportunités de cash back !',
        KE: 'Discover our latest casino promotions, including generous recharge bonuses and attractive cash back offers. Take advantage of special deals to boost your play and maximize your winnings. Check out our current activities and enhance your gaming experience with exclusive rewards and cash back opportunities!'
      }
    }
  }
  document.title = seo[currentPage].title[country]
  document.content = seo[currentPage].content[country]
}
function defaultCurrencyAlias() {
  const hostname = window.location.hostname
  let checkCountry = window.country || 'ET'
  switch (hostname) {
    // case 'lobby.megalake.games':
    case 'www.vivagame.et':
    case 'www.vivabet.et':
    case 'vivagame.et':
    case 'vivabet.et':
      checkCountry = 'ET'
      break
    case 'lobby-ci.megalake.games':
    case 'www.vivagame.africa':
    case 'vivagame.africa':
    case 'www.vivagame.ci':
    case 'vivagame.ci':
      checkCountry = 'CI'
      break
    case 'www.vivagame.ke':
    case 'www.vivabet.ke':
    case 'www.vivagame.co.ke':
    case 'vivagame.co.ke':
    case 'vivagame.ke':
    case 'vivabet.ke':
      checkCountry = 'KE'
      break
    case 'vivagame.co.tz':
    case 'www.vivagame.co.tz':
    case 'lobby.megalake.games':
      checkCountry = 'TZ'
      break
    case 'www.bigwins.com.gh':
      checkCountry = 'GH'
      break
    default:
      break
  }
  return { ET: 'ETB', CI: 'XOF', KE: 'KSH', GH: 'GHS', TZ: 'TSh' }[checkCountry]
}
function defaultHostname(country) {
  const hostname = window.location.hostname
  let checkCountry = ''
  switch (hostname) {
    case 'lobby.megalake.games':
    case 'www.vivagame.et':
    case 'www.vivabet.et':
    case 'vivagame.et':
    case 'vivabet.et':
      checkCountry = 'ET'
      break
    case 'lobby-ci.megalake.games':
    case 'www.vivagame.africa':
    case 'vivagame.africa':
    case 'www.vivagame.ci':
    case 'vivagame.ci':
      checkCountry = 'CI'
      break
    case 'lobby-ke.megalake.games':
    case 'www.vivagame.ke':
    case 'www.vivabet.ke':
    case 'www.vivagame.co.ke':
    case 'vivagame.co.ke':
    case 'vivagame.ke':
    case 'vivabet.ke':
      checkCountry = 'KE'
      break
    case 'www.vivagame.co.tz':
      // case 'lobby.megalake.games':
      checkCountry = 'TZ'
      break
    case 'www.bigwins.com.gh':
      checkCountry = 'GH'
      break
    default:
      break
  }
  window.bridge.$emit(BUS.REFRESH_PAGE)
  if (checkCountry != country && hostname != 'lobby.megalake.games') {
    const localHostName = {
      ET: 'www.vivagame.et',
      CI: 'www.vivagame.ci',
      KE: 'www.vivagame.ke',
      GH: 'www.bigwins.com.gh',
      TZ: 'www.vivagame.co.tz'
    }[country]
    const checkCid = localStorage.getItem('cid')
    if (checkCid && (checkCid == 'etAPP16' || checkCid == 'keAPP16')) {
      window.location.href =
        'https://' + localHostName + '?token=' + getLocalStorage(Key.Token) + '&cid=' + checkCid
    } else {
      window.location.href = 'https://' + localHostName + '?token=' + getLocalStorage(Key.Token)
    }
    return true
  }
  return false
}

/**
 * 活动动画
 * @param {*} canvas 画布
 */
function activeCanvasAnimation(
  canvas,
  innerWidth = window.innerWidth,
  innerHeight = window.innerHeight
) {
  var COLORS, Confetti, NUM_CONFETTI, PI_2, confetti, context, drawCircle, range, resizeWindow, xpos

  NUM_CONFETTI = 150

  COLORS = [
    [85, 71, 106],
    [174, 61, 99],
    [219, 56, 83],
    [244, 92, 68],
    [248, 182, 70]
  ]

  PI_2 = 2 * Math.PI

  // canvas = document.getElementById('world')
  if (!canvas) return
  context = canvas.getContext('2d')
  // 清除整个画布
  context.clearRect(0, 0, canvas.width, canvas.height)

  window.w = 0

  window.h = 0

  resizeWindow = function () {
    window.w = canvas.width = innerWidth
    return (window.h = canvas.height = innerHeight)
  }

  window.addEventListener('resize', resizeWindow, false)

  window.onload = function () {
    return setTimeout(resizeWindow, 0)
  }

  range = function (a, b) {
    return (b - a) * Math.random() + a
  }

  drawCircle = function (x, y, r, style) {
    context.beginPath()
    context.arc(x, y, r, 0, PI_2, false)
    context.fillStyle = style
    return context.fill()
  }

  xpos = 0.5

  document.onmousemove = function (e) {
    return (xpos = e.pageX / window.w)
  }

  window.requestAnimationFrame = (function () {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
    )
  })()

  Confetti = class Confetti {
    constructor() {
      this.style = COLORS[~~range(0, 5)]
      this.rgb = `rgba(${this.style[0]},${this.style[1]},${this.style[2]}`
      this.r = ~~range(2, 6) * 1 //0.5
      this.r2 = 2 * this.r
      this.replace()
    }

    replace() {
      this.opacity = 0
      this.dop = 0.03 * range(1, 4)
      this.x = range(-this.r2, window.w - this.r2)
      this.y = range(-20, window.h - this.r2)
      this.xmax = window.w - this.r
      this.ymax = window.h - this.r
      this.vx = range(0, 2) + 10 * xpos - 5
      return (this.vy = 0.7 * this.r + range(-1, 1))
    }

    draw() {
      var ref
      this.x += this.vx
      this.y += this.vy
      this.opacity += this.dop
      if (this.opacity > 1) {
        this.opacity = 1
        this.dop *= -1
      }
      if (this.opacity < 0 || this.y > this.ymax) {
        this.replace()
      }
      if (!(0 < (ref = this.x) && ref < this.xmax)) {
        this.x = (this.x + this.xmax) % this.xmax
      }
      return drawCircle(~~this.x, ~~this.y, this.r, `${this.rgb},${this.opacity})`)
    }
  }

  confetti = (function () {
    var j, i, ref, results
    results = []
    for (i = j = 1, ref = NUM_CONFETTI; 1 <= ref ? j <= ref : j >= ref; i <= ref ? ++j : --j) {
      results.push(new Confetti())
    }
    return results
  })()

  window.step = function () {
    var c, j, len, results
    requestAnimationFrame(window.step)
    context.clearRect(0, 0, window.w, window.h)
    results = []
    for (j = 0, len = confetti.length; j < len; j++) {
      c = confetti[j]
      results.push(c.draw())
    }
    return results
  }

  window.step()
}

function sleep(ms = 1000) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function enterEnvelop(isLogin) {
  //  红包活动
  if (isLogin) {
    window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
  } else {
    window.location.href = `${window.envelopeUrl}/?active=&lang=${getLocale()}&cid=hbzz&channel=web`
  }
}

/**
 * 平滑增加动画总金额，使其逐渐接近目标总金额
 * @param {number} animationTotalAmount - 当前动画总金额
 * @param {number} totleAmount - 目标总金额
 * @returns {number} - 更新后的动画总金额
 * @see 
 * ```js
 * methods: {
      mathTotalAmount() {
              this.animationTotalAmount = animateTotalAmount(this.animationTotalAmount, this.totleAmount);
              window.requestAnimationFrame(this.mathTotalAmount);
      },
    ...
    }
 * ```
 */
function animateTotalAmount(animationTotalAmount, totleAmount) {
  // 如果当前动画总金额小于目标总金额
  if (animationTotalAmount < totleAmount) {
    // 增加一个值，这个值是目标总金额的 1/84 和目标总金额与当前动画总金额之差中的较小值
    animationTotalAmount += Math.min(totleAmount / 84, totleAmount - animationTotalAmount)
  }
  // 否则，将当前动画总金额设置为目标总金额
  else {
    animationTotalAmount = totleAmount
  }
  // 返回更新后的动画总金额
  return animationTotalAmount
}

function formatPayChannelName(channel) {
  try {
    if (
      channel.routing == 'direct' &&
      channel.paymentMethod == 'telebirr' &&
      channel.payChannel == 'arifpay'
    ) {
      return 'telebirr'
    } else if (
      channel.routing == 'direct' &&
      channel.paymentMethod == 'cbebirr' &&
      channel.payChannel == 'arifpay'
    ) {
      return 'cbebirr'
    } else if (
      channel.routing == 'direct' &&
      channel.paymentMethod == 'mpesa' &&
      channel.payChannel == 'arifpay'
    ) {
      return 'mpesa'
    } else if (channel.routing == 'redirect' && channel.payChannel == 'arifpay') {
      return 'other'
    } else {
      return channel.payChannel
    }
  } catch (error) {
    return channel.payChannel || ''
  }
}

function checkLuckywheel() {
  return new Promise((resolve, reject) => {
    const dev_base_url = 'https://gw.megalake.games/v1/task/spin/num'
    const pro_base_rul = 'https://gw.vivagameclub.com/v1/task/spin/num'
    if (useUserStore().isLogin) {
      fetch(ENV == 'production' ? pro_base_rul : dev_base_url, {
        headers: {
          accept: 'application/json, text/plain, */*',
          'cache-control': 'no-cache',
          'content-type': 'application/json;charset=UTF-8',
          pragma: 'no-cache',
          token: getLocalStorage(Key.Token)
        },
        referrer: window.location.hostname,
        referrerPolicy: 'strict-origin-when-cross-origin',
        method: 'POST',
        mode: 'cors',
        credentials: 'omit'
      })
        .then((response) => {
          if (!response.ok) {
            // throw new Error(`HTTP error! status: ${response.status}`)
            reject(`HTTP error! status: ${response.status}`)
          }
          return response.json() // 将响应解析为 JSON
        })
        .then((data) => {
          // this.showLuckywheelTips = parseInt(data.data.spinNum) > 0
          console.log('spinNum:::====>>>>>', data.data.spinNum)
          resolve(parseInt(data.data.spinNum) > 0)
        }) // 处理成功的响应数据
        .catch((error) => console.error('Fetch error:', error)) // 处理错误;
    }
  })
}

const IOS = 'iOS'
const ANDROID = 'Android'
const WP = 'Windows Phone'
const ENV = import.meta.env.VITE_APP_ENV
const ISACTIVE = import.meta.env.VITE_IS_ACTIVE

export {
  checkLuckywheel,
  activeCanvasAnimation,
  ANDROID,
  animateTotalAmount,
  checkAndUpdateApp,
  chunkArray,
  copy,
  currentPage,
  decodeBase64,
  defaultCurrencyAlias,
  defaultHostname,
  downloadAPK,
  encodeBase64,
  enterEnvelop,
  ENV,
  fillterLongID,
  fillterLongUserName,
  findValueIn2DArray,
  formatDate,
  formatMoney,
  formatNavTab,
  getMobileOperatingSystem,
  getRandomIntInclusive,
  IOS,
  ISACTIVE,
  isNativeApp,
  parseUrl,
  removeThousandSeparatorWithDecimal,
  savePWA,
  setSEO,
  sleep,
  splitText,
  truncateText,
  unitConversion,
  WP,
  formatPayChannelName
}
